import DefaultCatalogConfig from './DefaultCatalogConfig';

export default class NotValidForStructureCatalogConfig extends DefaultCatalogConfig {
  canPaste = () => false;

  editable = false;

  indentTree = false;
}
